module.exports = __webpack_public_path__ + "bookmarkcosplay.webp?9ded9281b7de1ab68bc9992f2469092d";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/bookmarkcosplay.webp
// module id = 217
// module chunks = 0